import { render, staticRenderFns } from "./nearCausePrevention.vue?vue&type=template&id=23e0feeb"
import script from "./nearCausePrevention.vue?vue&type=script&lang=js"
export * from "./nearCausePrevention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e0feeb')) {
      api.createRecord('23e0feeb', component.options)
    } else {
      api.reload('23e0feeb', component.options)
    }
    module.hot.accept("./nearCausePrevention.vue?vue&type=template&id=23e0feeb", function () {
      api.rerender('23e0feeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearCausePrevention.vue"
export default component.exports